/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable import/no-unresolved */
import { useEffect, useState } from 'react'

import Image from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/router'
// import { Navigation, Pagination, Thumbs, FreeMode, Autoplay } from 'swiper'
// import { Swiper, SwiperSlide } from 'swiper/react'
// import 'swiper/css'
// import 'swiper/css/navigation'
// import 'swiper/css/pagination'
// import 'swiper/css/thumbs'
const Cards = ({ initiativeTrans, item }) => {
  const { locale } = useRouter()
  const loader = ({ src }) => {
    return src
  }
  const count = item.field_icons.split(', ')
  const [screenWidth, setScreenWidth] = useState(window.innerWidth)

  const handleWindowSizeChange = () => {
    setScreenWidth(window.innerWidth)
  }
  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange)
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [])

  return (
    <Link href={`${locale}/issi/${item?.nid}`} passHref>
      <div className="lg:p-6 p-3 sm:w-6/12 lg:w-1/3 cursor-pointer">
        <div className="h-full border border-grayscale-300 overflow-hidden relative px-8 py-6 flex flex-col">
          <div className={`${count > 1 ? 'mb-0' : 'mb-4'}`}>
            <div className={`${count > 1 ? 'h-[25px]' : 'h-[50px]'} justify-start items-center flex relative`}>
              {item.field_icons &&
                Object.keys(item.field_icons.split(', ')).map((index) => (
                  <Image
                    src={`${item.field_icons.split(', ')[index]}`}
                    loader={loader}
                    unoptimized={true}
                    width={screenWidth >= 900 ? 80 : 80}
                    height={80}
                    alt={item?.title}
                    className={`mb-0 w-auto h-auto ${
                      count.length > 1 ||
                      item.field_icons.split(', ')[index] ==
                        `${process.env.NEXT_PUBLIC_BASE_URL_BE_HOST}/index.php/sites/default/files/2023-07/Logo_Icon_1.png`
                        ? 'h-[70%]'
                        : 'h-[80%]'
                    }`}
                    key={index}
                  />
                ))}
            </div>
          </div>
          <span className="bg-grayscale-100 py-2 px-3 body-xs diodrum leading-normal mb-3 inline-block text-blackscale-500 absolute rtl:left-0 ltr:right-0 top-6">
            {locale === 'en' ? 'Industrial Motivation' : 'التحفيز الصناعي'}
          </span>
          <h5 className="lyon mb-4 text-blackscale-500 leading-normal">{item?.title}</h5>

          <p className="body-xs diodrum text-black leading-normal">
            {item?.body?.length <= 20 ? (
              <span dangerouslySetInnerHTML={{ __html: item?.body }}></span>
            ) : (
              <span
                dangerouslySetInnerHTML={{
                  __html: locale === 'en' ? item?.body.substring(0, 100) + '...' : item?.body.substring(0, 200) + '...',
                }}
              ></span>
            )}
          </p>
          <div className="mt-auto">
            <Link href={`${locale}/issi/${item?.nid}`}>
              <a className="btn btn-black text-sm py-3 mt-4 inline-block">
                {initiativeTrans?.initiative_details}
                <span className="rtl:align-middle rtl:mr-3 ltr:ml-3 ltr:rotate-180 inline-block leading-none before:bg-arrow-left-white before:inline-block before:w-[25px] before:h-[16px]"></span>
              </a>
            </Link>
          </div>
        </div>
      </div>
    </Link>
  )
}
export default Cards
